// extracted by mini-css-extract-plugin
export default {"wrapper":"Hs-z","response":"Is-z","error":"Js-z","disabled":"Ks-z","buttons":"Ls-z","feedbackQuestionSection":"Ms-z","yesNoWrapper":"Ns-z"};